import { useState, useEffect, useRef } from 'react';
import { Effects, BakeShadows } from '@react-three/drei';
import { UnrealBloomPass } from 'three-stdlib';
// import { UnrealBloomPass } from 'threejs/examples/jsm ';
import { Canvas, extend } from '@react-three/fiber';
import * as THREE from 'three';
import AddBox from './AddBox';
import AddPlane from './AddPlane';
import AddSphere from './AddSphere';
import AddTextGeometry from './AddTextGeometry';
// https://github.com/pmndrs/leva/blob/main/docs/getting-started.md
// https://codesandbox.io/s/github/sanjmgr/react-control-panel-leva
import { useControls } from 'leva';

import CameraOrbit from './CameraOrbit';
import styles from './scene.modules.sass';

extend({ UnrealBloomPass });

export default function Scene() {
  const [scale, setScale] = useState([1, 1, 1]);

  const {
    threshold,
    intensity,
    radius,
    text,
    textColor,
    emissiveColor,
    emissivePower,
  } = useControls({
    threshold: { value: 0.1, min: 0.01, max: 1, step: 0.01 },
    intensity: { value: 1.0, min: 0, max: 1.5, step: 0.01 },
    radius: { value: 0.27, min: 0, max: 1, step: 0.01 },
    text: { value: 'Hello Text!' },
    textColor: '#0049ff',
    emissiveColor: '#ff0000',
    emissivePower: { value: 1.9, min: 0, max: 10, step: 0.1 },
  });

  // https://codesandbox.io/s/bloom-hdr-workflow-gnn4yt?file=/src/App.js:162-174
  // https://codesandbox.io/s/bloom-hdr-workflow-gltf-whnhyr

  return (
    <Canvas
      camera={{ position: new THREE.Vector3(0, 1, 7) }}
      shadows
      gl={{ antialias: false }}
    >
      <color attach="background" args={['#202030']} />
      <fog attach="fog" args={['#202030', 10, 25]} />
      <Effects disableGamma>
        <unrealBloomPass
          threshold={threshold}
          strength={intensity}
          radius={radius}
        />
      </Effects>
      {/* <ambientLight intensity={1} color={0x777777} /> */}
      <hemisphereLight intensity={0.2} color="#eaeaea" groundColor="blue" />
      <BakeShadows />
      <directionalLight
        position={new THREE.Vector3(0, 1, 1.5)}
        intensity={0.5}
        color={'#aaaaaa'}
        // castShadow
        // visible
      />
      <CameraOrbit />
      {/* <group scale={1}>
        <AddBox pos={[-3, 2, 0]} initColor={'violet'} />
        <AddBox pos={[0, 2, 0]} initColor={'tomato'} />
        <AddBox pos={[3, 2, 0]} initColor={'orange'} />
      </group> */}
      {/* <AddSphere scale={scale} setScale={setScale} /> */}
      <AddPlane
        angleX={0}
        pos={[0, 5.0, 0]}
        animation={false}
        color={'#999999'}
      />
      <AddPlane
        angleX={Math.PI * -0.5}
        pos={[0, -2.0, 0]}
        animation={false}
        color={'green'}
      />
      <AddTextGeometry
        text={text}
        color={textColor}
        emissiveColor={emissiveColor}
        emissivePower={emissivePower}
      />
    </Canvas>
  );
}
